import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReviewIncludedForms = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.4 2.3C3.4 1.91 3.71 1.6 4.1 1.6H10.2C10.54 1.6 10.87 1.73 11.11 1.97L15.03 5.89C15.27 6.13 15.4 6.46 15.4 6.8V15.9C15.4 16.29 15.09 16.6 14.7 16.6H4.1C3.71 16.6 3.4 16.29 3.4 15.9V2.3Z",
			stroke: "currentColor",
			strokeWidth: 1,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.55 1.95V6.45H15.05",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.6 8H10.3",
			stroke: "currentColor",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.6 10.55H10.95",
			stroke: "currentColor",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.6 13.1H8.85",
			stroke: "currentColor",
			strokeWidth: 1.1,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.3,
			cy: 13.55,
			r: 2.45,
			fill: "white",
			stroke: "currentColor",
			strokeWidth: 1.35
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.05 15.3L17.15 17.4",
			stroke: "currentColor",
			strokeWidth: 1.35,
			strokeLinecap: "round"
		})
	]
});
export default SvgReviewIncludedForms;
